module.exports = __webpack_public_path__ + "img/MenuSecundario.020bb350.svg";